import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	isRequest: ForNodeType<boolean>;
	onSetViewModel: (
		values: {
			key: "isRequest";
			value: ForNodeType<boolean>;
		}[],
	) => void;
};

export const usePlanIsRequest = ({ isRequest, onSetViewModel }: Props) => {
	const onSetIsRequest = (value: boolean) => {
		onSetViewModel([
			{
				key: "isRequest",
				value: {
					isEdited: true,
					value,
				},
			},
		]);
	};

	return {
		isRequest,
		onSetIsRequest,
	};
};
